// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import StimulusControllerResolver from 'stimulus-controller-resolver'

import { Autocomplete } from 'stimulus-autocomplete'
import Lightbox from 'stimulus-lightbox'

application.register('autocomplete', Autocomplete)
application.register('lightbox', Lightbox)

StimulusControllerResolver.install(application, async controllerName => (
  (await import(`../controllers/${controllerName.replaceAll('-', '_')}_controller.js`)).default
))
